var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVal4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2919 51.584C31.9998 51.584 38.4328 48.9193 43.176 44.1762C47.9192 39.433 50.5838 32.9999 50.5838 26.2921C50.5838 19.5842 47.9192 13.1511 43.176 8.40799C38.4329 3.66483 31.9998 1.00015 25.2919 1.00015L25.2919 26.2921L25.2919 51.584Z",
    fill: "#FF7D85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2921 64.584C18.5842 64.584 12.1511 61.9193 7.40798 57.1762C2.66483 52.433 0.000150799 45.9999 0.000148773 39.2921C0.000146747 32.5842 2.66482 26.1511 7.40797 21.408C12.1511 16.6648 18.5842 14.0002 25.2921 14.0001L25.2921 39.2921L25.2921 64.584Z",
    fill: "#47BDFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVal4);
export default __webpack_public_path__ + "static/media/val4.9e469052538602654f6c8da43bef0e22.svg";
export { ForwardRef as ReactComponent };